module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-37.cfc0e6ee.png";